import { render } from "./MyCommentsListing.vue?vue&type=template&id=554b2b49"
import script from "./MyCommentsListing.vue?vue&type=script&lang=js"
export * from "./MyCommentsListing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__